import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    OnInit
} from '@angular/core';

import { HomeData, SiteApiService } from '../../core/services/api.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {

    data: HomeData | null = null;
    loading = false;
    errorMessage = '';

    private observer: IntersectionObserver | null = null;
    private mouseMoveHandler: any;

    constructor(
        private siteApi: SiteApiService,
        private elementRef: ElementRef
    ) { }

    ngOnInit(): void {
        this.getHome();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.initRevealAnimation();
            this.initHeroParallax();
        }, 300);
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }

        const hero = this.elementRef.nativeElement.querySelector('.hero');

        if (hero && this.mouseMoveHandler) {
            hero.removeEventListener('mousemove', this.mouseMoveHandler);
        }
    }

    getHome(): void {
        this.loading = true;
        this.errorMessage = '';

        this.siteApi.getHome().subscribe(
            (res: HomeData) => {
                this.data = res;
                this.loading = false;

                setTimeout(() => {
                    this.initRevealAnimation();
                    this.initHeroParallax();
                }, 150);
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Home page data could not be loaded.';
                this.loading = false;
            }
        );
    }

    private initRevealAnimation(): void {
        const elements = this.elementRef.nativeElement.querySelectorAll('.reveal');

        if (!elements || elements.length === 0) {
            return;
        }

        if (this.observer) {
            this.observer.disconnect();
        }

        this.observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const el = entry.target as HTMLElement;
                        el.classList.add('show');
                        this.observer?.unobserve(el);
                    }
                });
            },
            {
                threshold: 0.14
            }
        );

        elements.forEach((el: HTMLElement) => {
            el.classList.remove('show');
            this.observer?.observe(el);
        });
    }

    private initHeroParallax(): void {
        const hero = this.elementRef.nativeElement.querySelector('.hero') as HTMLElement;
        const visual = this.elementRef.nativeElement.querySelector('.hero-visual') as HTMLElement;
        const panels = this.elementRef.nativeElement.querySelectorAll('.floating-panel');

        if (!hero || !visual) {
            return;
        }

        this.mouseMoveHandler = (event: MouseEvent) => {
            const rect = hero.getBoundingClientRect();
            const x = (event.clientX - rect.left) / rect.width - 0.5;
            const y = (event.clientY - rect.top) / rect.height - 0.5;

            visual.style.transform = `translate3d(${x * 16}px, ${y * 14}px, 0)`;

            panels.forEach((panel: HTMLElement, index: number) => {
                const depth = (index + 1) * 7;
                panel.style.transform = `translate3d(${x * depth}px, ${y * depth}px, 0)`;
            });
        };

        hero.addEventListener('mousemove', this.mouseMoveHandler);

        hero.addEventListener('mouseleave', () => {
            visual.style.transform = 'translate3d(0,0,0)';

            panels.forEach((panel: HTMLElement) => {
                panel.style.transform = 'translate3d(0,0,0)';
            });
        });
    }
}